<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <fui-two-columns>
                    <fui-column><wbo-date-edit-control formControlName="singleDate" [(ngModel)]="model.data.singleDate"></wbo-date-edit-control></fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns [label]="'wbo.report.edit.options'">
                    <fui-column>
                        <wbo-single-select-edit-control [formControlName]="'reportType'"
                                                        [(ngModel)]="model.data.reportType"
                                                        [allowClearSelectionOption]="false">
                            <wbo-select-options>
                                <wbo-select-option [value]="'Report By Week'"
                                                   label="wbo.sales-by-half-hour-report.option.reportType.report-by-week">
                                </wbo-select-option>
                                <wbo-select-option [value]="'Report By Day'"
                                                   label="wbo.sales-by-half-hour-report.option.reportType.report-by-day">
                                </wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-tax-inclusive-report-criteria></wbo-tax-inclusive-report-criteria>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
